var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{directives:[{name:"lazysizes",rawName:"v-lazysizes"}],staticClass:"lazyload",class:_vm.styles.root,attrs:{"data-src":_vm.src,"alt":_vm.alt,"width":_vm.size.width,"height":_vm.size.height},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }